export default __webpack_public_path__ + "static/media/3536 spice rack B side.0efc7631.png";